/*
 Copyright (C) 2022-present Wong Chun Yat (wcyat)

 This program is free software: you can redistribute it and/or modify
 it under the terms of the GNU Affero General Public License as
 published by the Free Software Foundation, either version 3 of the
 License, or (at your option) any later version.

 This program is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Affero General Public License for more details.

 You should have received a copy of the GNU Affero General Public License
 along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */

import React, { useMemo } from "react";
import { PaletteColorOptions } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { memo } from "react";

declare module "@mui/material/styles" {
    interface Theme {
        status: {
            danger: string;
        };
    }

    interface ThemeOptions {
        status?: {
            danger?: string;
        };
    }
}
const Theme = memo(function Theme(props: {
    primary?: PaletteColorOptions;
    secondary?: PaletteColorOptions;
    mode?: "dark" | "light";
    children: JSX.Element | JSX.Element[];
}) {
    const theme = useMemo(
        () =>
            createTheme({
                palette: {
                    mode: props.mode || "dark",
                    primary: props.primary,
                    secondary: props.secondary,
                },
                typography: {
                    fontFamily: ["Roboto", "Arial", "sans-serif"].join(","),
                },
            }),
        [props.mode, props.primary, props.secondary]
    );
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
});
export default Theme;
